import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionTag from "@/components/base/SectionTag";
import { submitFlow } from "@/mocks/content";

export default function ProcessSection() {
  return (
    <section className="w-full bg-foreground-950 py-20 md:py-28" id="submit-flow">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-20">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionTag tone="light">投稿路径</SectionTag>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              三步之内，
              <br />
              完成一次安全的投递
            </h2>
            <p className="mt-5 text-sm leading-7 text-background-200/80 md:text-[15px]">
              我们刻意把流程做短。你不需要注册账号、不需要实名、也不需要一次交出全部材料。
              每一步你都可以停下来重新判断，是否继续。
            </p>

            <div className="mt-9 h-[240px] w-full overflow-hidden rounded-xl border border-background-50/10 md:h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=moody%20low%20key%20desk%20view%20of%20a%20sealed%20manila%20envelope%20stacked%20folded%20documents%20and%20a%20small%20voice%20recorder%20under%20a%20single%20warm%20desk%20lamp%2C%20deep%20charcoal%20shadows%2C%20crimson%20subtle%20rim%20light%2C%20fine%20film%20grain%2C%20editorial%20investigative%20photography&width=1100&height=1300&seq=anxian-desk-docs&orientation=landscape"
                alt="台灯下密封信封与纸质材料，代表爆料线索的原始素材"
                title="独家爆料投稿 - 原始素材与文件提交"
                className="h-full w-full object-cover object-top"
              />
            </div>

            <Link
              to="/submit"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
            >
              直接进入提交通道
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <ol className="relative space-y-10 border-l border-background-50/15 pl-8">
            {submitFlow.map((step, index) => (
              <Reveal key={step.step} delay={index * 90}>
                <li className="relative">
                  <span className="absolute -left-[45px] flex h-9 w-9 items-center justify-center rounded-full border border-accent-400/50 bg-foreground-950 font-heading text-xs font-bold text-accent-300">
                    {step.step}
                  </span>
                  <h3 className="font-heading text-xl font-semibold text-background-50">{step.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-background-200/80">{step.desc}</p>
                  <ul className="mt-5 flex flex-wrap gap-2">
                    {step.points.map((point) => (
                      <li
                        key={point}
                        className="rounded-full border border-background-50/15 px-3 py-1 text-xs text-background-200/85"
                      >
                        {point}
                      </li>
                    ))}
                  </ul>
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}